import { Avatar, Link, Typography } from '@mui/material';
import { Download } from 'Images';

interface ILinkDownload {
  text: string;
  callback: Function;
}

export const LinkDownload = ({ text, callback }: ILinkDownload) => {
  return (
    <Link
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '7px',
        textDecoration: 'none',

        ':hover': {
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      }}
      onClick={() => callback()}
    >
      <Typography>{text}</Typography>
      <Avatar alt='' src={Download} sx={{ width: '20px', height: '20px' }} />
    </Link>
  );
};
